/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { FeedbackPayload } from '../models/FeedbackPayload';
import type { SalesRequestDTO } from '../models/SalesRequestDTO';
import type { StudioPayload } from '../models/StudioPayload';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class HomeService {

    /**
     * Send feedback from our users to our klangio email channels.
     * @param requestBody Relevant payload to send and structure the feedback
     * @returns any When the feedback could not be processed for any reason.
     * or
     * Feedback has been send into our support channels.
     * @throws ApiError
     */
    public static homeFeedback(
        requestBody: FeedbackPayload,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/Home/Feedback',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @param requestBody
     * @returns binary
     * @throws ApiError
     */
    public static homeSalesRequest(
        requestBody: SalesRequestDTO,
    ): CancelablePromise<Blob> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/Home/salesRequest',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @param requestBody
     * @returns binary
     * @throws ApiError
     */
    public static homeStudioSubscribe(
        requestBody: StudioPayload,
    ): CancelablePromise<Blob> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/Home/StudioSubscribe',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

}
